<ng-container *ngIf="!item.hidden">
  <a
    *ngIf="item && item.url && (!item.children || item.children?.length === 0)"
    [routerLink]="item.url"
    routerLinkActive
    #rla="routerLinkActive"
    [class.active]="rla.isActive || isUrlActive(item.url)"
    class="d-flex align-items-center px-8 position-relative"
  >
    <py-badge *ngIf="notificationCount > 0" id="menu-approvals-badge" [position]="'center-left'" [isNotification]="true">
      {{ notificationCount }}
    </py-badge>

    <i nz-icon nzType="{{ parseIcon(item.styleClasses) }}" nzTheme="outline" class="mr-4 d-flex align-items-center"></i>
    {{ item.title }}
  </a>

  <div
    routerLinkActive
    #rla="routerLinkActive"
    [class.active]="rla.isActive || hasActiveChildRoute()"
    *ngIf="item.children && item.children?.length > 0"
    class="d-flex flex-column collapsed-holder"
  >
    <ng-template
      *ngTemplateOutlet="collapsedItemTemplate; context: { $implicit: { icon: item.styleClasses, title: item?.title } }"
    ></ng-template>

    <ul class="p-0" class="nav-children" [ngbCollapse]="isCollapsed" *ngIf="item.children && item.children.length > 0">
      <li *ngFor="let child of item.children">
        <a
          *ngIf="!child.hidden"
          [routerLink]="child.url"
          routerLinkActive
          #rla="routerLinkActive"
          [class.active-subitem]="rla.isActive || isUrlActive(child.url)"
          class="d-flex align-items-center pl-13"
        >
          <i nz-icon nzType="arrow-right" nzTheme="outline" class="mr-2 arrow-icon"></i>
          {{ child.title }}
        </a>
      </li>
    </ul>
  </div>
</ng-container>

<!-- Dynamic Price Campaigns Node -->
<ng-container *ngIf="item?.itemType === 'CmsMyPagePriceCampaignsComponent'">
  <ng-container *ngIf="priceCampaigns$ | async as priceCampaigns">
    <li class="wrapper" *ngIf="priceCampaigns?.entries?.length > 0">
      <div class="d-flex flex-column collapsed-holder">
        <ng-template
          *ngTemplateOutlet="collapsedItemTemplate; context: { $implicit: { icon: 'campaigns-link', title: item?.title } }"
        ></ng-template>

        <ul class="p-0" class="nav-children" [ngbCollapse]="isCollapsed">
          <li *ngFor="let priceCampaign of priceCampaigns?.entries">
            <a class="d-flex align-items-center pl-13" (click)="navigateToPriceCampaign(priceCampaign?.link)">
              <i nz-icon nzType="arrow-right" nzTheme="outline" class="mr-2 arrow-icon"></i>
              {{ priceCampaign?.description }}
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ng-container>
</ng-container>

<!-- Collapsed Item Template -->
<ng-template #collapsedItemTemplate let-data>
  <div class="d-flex align-items-center px-8 collapsed-item" (click)="toggleCollapsed()">
    <py-badge *ngIf="notificationCount > 0" id="menu-approvals-badge" [position]="'center-left'" [isNotification]="true">
      {{ notificationCount }}
    </py-badge>
    <i nz-icon nzType="{{ parseIcon(data.icon) }}" nzTheme="outline" class="mr-4 d-flex align-items-center"></i>
    {{ data.title }}
    <i nz-icon nzType="{{ isCollapsed ? 'down' : 'up' }}" nzTheme="outline" class="ml-2 d-flex ml-auto align-items-center"></i>
  </div>
</ng-template>
